import { useRef, useState } from 'react';
import { LuClock3, LuGlobe, LuMail } from 'react-icons/lu';
import { ProjectRequestForm } from '../components/HomePage/ProjectRequest/ProjectRequest';
import pointCloudBuilding from './Contacts/assets/contact-point-cloud-building.png';
import './Contacts.css';

const contactItems = [
  {
    id: 'email',
    icon: LuMail,
    label: 'Написать напрямую',
    content: (
      <a href="mailto:contact@dotpolyline.com">contact@dotpolyline.com</a>
    ),
  },
  {
    id: 'response-time',
    icon: LuClock3,
    label: 'Время ответа',
    content: <span>В течение одного рабочего дня</span>,
  },
  {
    id: 'geography',
    icon: LuGlobe,
    label: 'География',
    content: <span>Работаем с клиентами по всему миру</span>,
  },
];

const serviceNames = {
  '2d-cad': '2D CAD Drawings',
  '3d-bim': '3D / BIM Model',
  'as-built': 'As-Built Documentation',
  other: 'Other',
};

export const sendProjectRequest = ({ name, email, company, service, description, link }) => {
  const requestEndpoint = process.env.REACT_APP_PROJECT_REQUEST_ENDPOINT;

  if (requestEndpoint) {
    // The server must accept the request and explicitly reply { received: true }.
    return fetch(requestEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, email, company, service, description, link }),
    }).then(async response => {
      if (!response.ok) throw new Error('Project request was not accepted');
      const result = await response.json();
      if (result?.received !== true) throw new Error('Receipt was not confirmed');
      return { confirmed: true };
    });
  }

  const body = [
    `Имя: ${name}`,
    `Email: ${email}`,
    `Компания: ${company || '—'}`,
    `Услуга: ${serviceNames[service]}`,
    '',
    'Описание проекта:',
    description,
    '',
    `Ссылка на файлы: ${link || '—'}`,
  ].join('\n');

  window.location.href = `mailto:contact@dotpolyline.com?subject=${encodeURIComponent(
    'Запрос оценки проекта'
  )}&body=${encodeURIComponent(body)}`;

  // Opening a mail draft does not confirm delivery, so keep the entered data.
  return false;
};

const Contacts = () => {
  const formPanelRef = useRef(null);
  const [confirmedFormHeight, setConfirmedFormHeight] = useState(null);

  const handleConfirmed = () => {
    setConfirmedFormHeight(formPanelRef.current?.getBoundingClientRect().height || null);
  };

  return (
    <main className="section contacts-page">
      <div className="container">
        <header className="contacts-page__header">
          <h1 className="title-1 contacts-page__title">Запросить оценку проекта</h1>
          <p className="contacts-page__lead">
            Заполните форму или напишите нам напрямую.
          </p>
        </header>

        <div
          className={`contacts-page__layout${confirmedFormHeight ? ' is-confirmed' : ''}`}
          style={confirmedFormHeight
            ? { '--initial-form-height': `${confirmedFormHeight}px` }
            : undefined}
        >
          <section
            className="contacts-page__info"
            aria-labelledby="contacts-info-title"
          >
            <div className="contacts-page__info-card">
              <h2 className="contacts-page__section-title" id="contacts-info-title">
                Контактная информация
              </h2>
              {contactItems.map(({ content, icon: Icon, id, label }) => (
                <article className="contacts-page__info-item" key={id}>
                  <span className="contacts-page__icon" aria-hidden="true">
                    <Icon />
                  </span>
                  <div className="contacts-page__info-copy">
                    <h3>{label}</h3>
                    {content}
                  </div>
                </article>
              ))}
            </div>

            <div className="contacts-page__visual" aria-hidden="true">
              <img
                src={pointCloudBuilding}
                alt=""
                className="contacts-page__visual-image"
              />
            </div>
          </section>

          <section
            id="project-request"
            ref={formPanelRef}
            className="project-request__panel contacts-page__form-panel"
            aria-labelledby="contacts-form-title"
          >
            <ProjectRequestForm
              idPrefix="contacts-project-request"
              onSubmitRequest={sendProjectRequest}
              headingId="contacts-form-title"
              headingClassName="contacts-page__form-title"
              onConfirmed={handleConfirmed}
              onReset={() => setConfirmedFormHeight(null)}
            />
          </section>
        </div>
      </div>
    </main>
  );
};

export default Contacts;
